import { defineCustomElement } from '@tyler-components-web/core';
import { ToolbarComponent } from './toolbar';
export * from './toolbar-constants';
export * from './toolbar';
export function defineToolbarComponent() {
    defineCustomElement(ToolbarComponent);
}
